import React from "react";
import { MDBCard, MDBRow, MDBCol, MDBCardText, MDBCardTitle, MDBFile, MDBCardBody, MDBIcon, MDBCardHeader, MDBInput, MDBBtn, MDBSwitch } from "mdb-react-ui-kit";
import "./Teacher.css";
import { useNavigate } from "react-router-dom";

const Teacher = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="profile">
        <MDBCard shadow="10" border="success" background="white" className="mb-2" style={{ maxWidth: "10rem" }}>
          <MDBCardHeader>
            <MDBIcon fas icon="user-circle" size="3x" />
          </MDBCardHeader>
          <MDBCardBody>
            <MDBCardTitle>مریم حسنی</MDBCardTitle>
          </MDBCardBody>
          <MDBBtn color="danger" onClick={() => navigate("/")}>
            خروج
          </MDBBtn>
        </MDBCard>
      </div>
      <div className="Dashbord">
        <MDBRow className="row-cols-1 row-cols-md-2 g-4">
          <MDBCol>
            <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
              <MDBCardHeader>ویدئوهای آپلود شده</MDBCardHeader>
              <MDBCardBody>
                <MDBCardText>420 ویدئو</MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
              <MDBCardHeader>تعداد دانشجو</MDBCardHeader>
              <MDBCardBody>125 نفر</MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
              <MDBCardHeader>پیام های خوانده نشده</MDBCardHeader>
              <MDBCardBody>
                <MDBCardText> 10 عدد</MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol>
            <MDBCard background="light" className="mb-3" style={{ maxWidth: "18rem" }}>
              <MDBCardHeader>کلاس های فعال</MDBCardHeader>
              <MDBCardBody>
                <MDBCardText>کلاس 10</MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>

        {/* <Player src="https://zabanamooz.herokuapp.com/media/%DA%A9%D9%84%DB%8C%D9%BE_%DA%A9%D9%88%D8%AA%D8%A7%D9%87_%D9%88%D9%84%D9%86%D8%AA%D8%A7%DB%8C%D9%86_%D9%85%D8%A8%D8%A7%D8%B1%DA%A9_-_%D8%B9%D8%B4%D9%82%D9%85_%D9%88%D8%B6%D8%B9%DB%8C%D8%AA_%D9%88%D8%A7%D8%AA%D8%B3%D8%A7%D9%BE_auto.mp4" /> */}
      </div>
      <div className="Form">
        <form>
          <MDBInput id="form4Example1" wrapperClass="mb-4" label="نام ویدئو" />
          <MDBInput type="name" id="form4Example2" wrapperClass="mb-4" label="نام مدرس" />
          <MDBInput wrapperClass="mb-4" textarea id="form4Example3" rows={4} label="توضیحات" />
          <MDBSwitch id="flexSwitchCheckDefault" label="قابلیت دانلود" />
          <br />
          <MDBFile label="انتخاب ویدئو" id="customFile" /> <br />
          <MDBBtn type="submit" className="mb-4" block>
            ارسال
          </MDBBtn>
        </form>
      </div>
    </div>
  );
};

export default Teacher;
